import { createStore } from "redux";
import { persistStore } from "redux-persist";

import middlewares from "./middlewares";
import reducers from "./reducers";

const store = createStore(reducers, middlewares);

const persistor = persistStore(store);

export { store, persistor };
